// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"04b0b702","429":"da049511","507":"4941c306","810":"9698a67d","923":"c1c3d954"}[chunkId] + ".chunk.js";
};